import React from 'react';
import {useNavigate} from 'react-router-dom';
import {ProfileAlertsBanner, TermsDocumentsList} from 'features/profile';
import {ROUTES} from 'app/router/routes';
import styles from './ProfileDataPage.module.css';

const backIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M10 6L4 12L10 18" stroke="currentColor" strokeWidth="1.6" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 12.9135L5 12.9135L5 11.1992L20 11.1992L20 12.9135Z"
			fill="currentColor"
		/>
	</svg>
);

export function ProfileTermsPage(): React.ReactElement {
	const navigate = useNavigate();

	return (
		<div className={styles.root}>
			<header className={styles.header}>
				<button
					type="button"
					className={styles.backButton}
					onClick={() => navigate(ROUTES.profile)}
					aria-label="Назад"
				>
					{backIcon}
				</button>
				<h1 className={styles.title}>Условия и правила</h1>
			</header>

			<div className={styles.content}>
				<div className={styles.contentInner}>
					<ProfileAlertsBanner />
					<TermsDocumentsList />
				</div>
			</div>
		</div>
	);
}
